

































































































import { Component, Vue } from 'vue-property-decorator'
import { hasArray, hasOwnProp } from '@/utils'
import { Load, cloner } from '@/units'
import { setSession } from '@/service/sessionStorage.service'
import './style.less'

@Component
export default class Dashboard extends Vue {
  constructor () {
    super()

    console.info('📦 [Dashboard] componentDidMount....')
  }

  // __DATA
  private currentView: number = 0

  // __METHODS
  private stream (): void {
    setSession('APP.Streaming', this.currentView)
    this.$router.push({
      name: 'stream'
    })
  }

  private wizard (param: any): void {
    if (param.isActive) {
      this.$router.push({
        name: 'wizard',
        query: {
          i: param.rtsp_link
        }
      })
    }
  }

  private count (param: any): number {
    let results: number = 0
    if (hasArray(param)) {
      for (const v of param) {
        results += hasArray(v.cameras)
      }
    }
    return results
  }

  private focus (param: any): boolean {
    if (hasArray(this.permise) && !this.currentView) {
      this.currentView = this.permise[0].id
    }

    return this.currentView === param.id
  }

  private recent (param: any): string {
    return hasOwnProp(param, 'recent') && param.recent
      ? param.recent.access_on
      : Date.now()
  }

  // __COMPUTED
  private get user (): any {
    return this.$store.getters['APP.AUTH/user']
  }

  private get permise (): any {
    let results: any = []

    if (hasOwnProp(this.user, 'permission')) {
      const v: any = cloner(this.user.permission.views)
      results = v
        .remove('isActive', 0)
        .orderBy('name', 'asc')
    }

    return results
  }

  private get views (): any {
    const h: any = this.permise.find((x: any) => x.id === this.currentView)
    return h ? h.cameras : []
  }
}
